const property = {
  property: {
    breadcrumbProperty: 'Propiedad',
    backToResults: 'Volver a resultados',
    guestsCount: '{{count}} huéspedes',
    loadingMessage: 'Cargando detalles de la propiedad...',
    errorTitle: 'Propiedad no encontrada',
    errorMessage: 'No se pudieron cargar los detalles de esta propiedad. Verifique el enlace o intente nuevamente.',
    availableUnits: '{{count}} unidad{{suffix}} disponible{{suffix}}',
    noAvailability: 'Sin disponibilidad',
    photoAlt: 'Foto {{index}}',
    aboutProperty: 'Sobre la propiedad',
    amenities: 'Comodidades',
    accommodations: 'Alojamientos',
    pricingForDates: 'Precios para {{nights}} {{nightLabel}} · {{checkIn}} → {{checkOut}}',
    selectDatesHint: 'Seleccione fechas en la búsqueda para ver precios y disponibilidad.',
    available: 'Disponible',
    unavailable: 'No disponible',
    upToGuests: 'Hasta {{count}} huéspedes',
    included: 'incluidos',
    perNightTotal: '/ noche · total',
    unavailableForDates: 'No disponible para estas fechas',
    bookNow: 'Reservar ahora',
    noUnitsAvailable: 'Ninguna unidad disponible para las fechas seleccionadas.',
    tryOtherDates: 'Pruebe otras fechas',
    reviews: 'Valoraciones',
    verified: 'Verificada',
    location: 'Ubicación',
    viewOnMaps: 'Ver en Google Maps',
    contact: 'Contacto',
    officialSite: 'Sitio oficial',
    whatsappContact: 'Hablar por WhatsApp',
    pageTitle: '{{name}} - Reserve Connect',
    pageTitleFallback: 'Propiedad - Reserve Connect',
    pageDescription: '{{description}} en {{city}}. Consulte disponibilidad y precios reales.',
    pageDescriptionFallback: 'Detalles de la propiedad en Reserve Connect.',

    // Cancellation policy display
    policyFlexible: 'Cancelación Gratuita',
    policyFlexibleBadge: 'Cancelación Gratuita',
    policyFlexibleDesc: 'Cancelación gratuita hasta 24 horas antes del check-in.',
    policyModerate: 'Moderado',
    policyModerateBadge: 'Moderado',
    policyModerateDesc: 'Cancelación gratuita hasta 5 días antes. Hasta 24 horas antes, 50% de reembolso.',
    policyStrict: 'Estricto',
    policyStrictBadge: 'Estricto',
    policyStrictDesc: '50% de reembolso hasta 7 días antes. Después de eso, no hay reembolso.',
    policyUnknown: 'Política de cancelación',
    policyUnknownDesc: 'Consulte los términos de la reserva para detalles sobre cancelación.',
    policyLearnMore: 'Más información',
  },
};
export default property;
